module.exports = __webpack_public_path__ + "0f6dccc65b93224f31ecbebc3c2f03f9.png";